import {
	NodeViewContent,
	type NodeViewProps,
	NodeViewWrapper,
} from '@tiptap/react'

const Component = (props: NodeViewProps) => {
	return (
		<NodeViewWrapper>
			<NodeViewContent>
				<p>I am a spacer</p>
			</NodeViewContent>
		</NodeViewWrapper>
	)
}

export default Component
